import React from 'react'

const MobilityMonitorPrivacyPolicy = () => {
    return (
        <div className="privacy-page">
            <div className="privacy-card">
                <h1 className="privacy-title">Privacy Policy</h1>
                <p className="privacy-subtitle">Mobility Monitor</p>

                <p className="privacy-subtitle">Last updated: March 2, 2026</p>

                <p className="privacy-text">
                    Mobility Monitor ("we", "our", or "us") values your privacy. This Privacy
                    Policy explains how we collect, use, and protect your personal
                    information.
                </p>

                <h3>1. Introduction</h3>
                <p className="privacy-text">
                    This Privacy Policy applies to our mobile application and governs data collection and usage.
                </p>

                <h3>2. Information We Collect</h3>
                <p className="privacy-text">We may collect the following personal information:</p>
                <ul>
                    <li>Name</li>
                    <li>Email address</li>
                    <li>Telephone number</li>
                </ul>

                <h3>3. How We Use Your Information</h3>
                <p className="privacy-text">Your information is used to:</p>
                <ul>
                    <li>Create and manage your account</li>
                    <li>Contact you regarding services</li>
                    <li>Provide customer support</li>
                    <li>Improve app functionality</li>
                </ul>

                <h3>4. Data Sharing</h3>
                <p className="privacy-text">
                    We do not sell your personal information. Your data is not shared with
                    third parties except when required by law.
                </p>

                <h3>5. Data Security</h3>
                <p className="privacy-text">
                    We implement reasonable technical and organizational measures to
                    protect your data using secure servers and encrypted connections.
                </p>

                <h3>6. Data Retention</h3>
                <p className="privacy-text">
                    We retain your personal information only as long as necessary to provide
                    our services.
                </p>

                <h3>7. Account Deletion</h3>
                <p className="privacy-text">
                    You can delete your account at any time directly within the app:
                </p>
                <p className="privacy-text"><strong>Menu → Settings → Delete Account</strong></p>

                <p className="privacy-text">Once you confirm deletion:</p>
                <ul>
                    <li>Your personal information is permanently removed from our system.</li>
                    <li>Your account credentials become invalid immediately.</li>
                    <li>Associated records are erased.</li>
                    <li>Any backup data (if applicable) is deleted within 30 days.</li>
                </ul>

                <h3>8. Your Rights</h3>
                <ul>
                    <li>Access your personal information</li>
                    <li>Request correction or deletion of your data</li>
                </ul>

                <h3>9. Contact Us</h3>
                <p className="privacy-text">
                    If you have any questions about this Privacy Policy, contact us at:
                </p>
                <p className="privacy-email">support@mobilitymonitor.com</p>

                <hr style={{ marginTop: "40px", border: "0", borderTop: "1px solid #eee" }} />
                <p style={{ fontSize: "14px", color: "#777", textAlign: "center" }}>
                    © 2026 Mobility Monitor. All rights reserved.
                </p>
            </div>
        </div>)
}

export default MobilityMonitorPrivacyPolicy